import { APP_ROUTES } from './routes'

export type NavItem = {
  to: string
  label: string
  icon: 'overview' | 'inventory' | 'locations' | 'orders' | 'settings'
}

export const NAV_ITEMS: NavItem[] = [
  { to: APP_ROUTES.home, label: 'Overview', icon: 'overview' },
  { to: APP_ROUTES.inventory, label: 'Products', icon: 'inventory' },
  { to: APP_ROUTES.locations, label: 'Location', icon: 'locations' },
  { to: APP_ROUTES.orders, label: 'Orders', icon: 'orders' },
  { to: APP_ROUTES.settings, label: 'Settings', icon: 'settings' },
]
